"use strict";
const localhost = '127.0.0.1:9292';
const { host } = window.location;
__webpack_public_path__ =
    host === localhost ? `http://${localhost}/assets/` : `https:${window.Cell.assetsPath}`;
